import { Instagram, Mail, MapPin } from "lucide-react";
import { BRAND } from "@/data/content";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-amber-500/10 px-6 pb-10 pt-16 sm:px-10 lg:px-16">
      <div className="flex flex-wrap items-start justify-between gap-10">
        <div>
          <div className="flex items-center gap-8">
            <img
              src={BRAND.logo}
              alt="Rock Raven Live Fire Cooking"
              data-testid="footer-logo"
              className="w-44"
            />
            <div
              data-testid="footer-lfca-emblem"
              className="inline-block transition-transform duration-300 hover:scale-105"
            >
              <img
                src="/lfca-wide.png"
                alt="LFCA — Live Fire Cooking Association, Est. 2026"
                className="h-14 w-auto sm:h-16"
              />
            </div>
            <a
              href="http://www.fliprogram.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-flip-seal"
              className="inline-block transition-opacity duration-300 hover:opacity-80"
            >
              <img
                src="https://app.fliprogram.com/uploads/seals/site-seal_128x128%20White.png"
                alt="FLIP Insurance Seal"
                width="128"
                height="128"
                className="h-32 w-32"
              />
            </a>
          </div>
          <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-neutral-500">
            {BRAND.tagline} — hardwood fire, iron, and honest ingredients brought to
            your table.
          </p>
          <p className="mt-3 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">
            <MapPin className="size-3.5 text-ember/70" /> {BRAND.location}
          </p>
        </div>
        <div className="flex gap-14">
          <div>
            <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-600">
              Inquiries
            </p>
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="footer-email-link"
              className="flex items-center gap-2 text-sm text-neutral-300 transition-colors hover:text-amber-400"
            >
              <Mail className="size-4 text-ember/70" /> {BRAND.email}
            </a>
          </div>
          <div>
            <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-600">
              Follow
            </p>
            <a
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="flex items-center gap-2 text-sm text-neutral-300 transition-colors hover:text-amber-400"
            >
              <Instagram className="size-4 text-ember/70" /> {BRAND.instagram}
            </a>
          </div>
        </div>
      </div>

      <h2
        aria-hidden="true"
        className="mt-16 select-none bg-gradient-to-b from-amber-500/25 to-transparent bg-clip-text text-center font-serif text-[13vw] uppercase leading-[0.85] text-transparent"
      >
        {BRAND.name}
      </h2>

      <div className="mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-neutral-800/60 pt-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">
          © {new Date().getFullYear()} {BRAND.name} — Live Fire Private Dining
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">
          Wood • Iron • Smoke
        </p>
      </div>
    </footer>
  );
}
